import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";
import { useRouter } from "next/router";
import { applyLocaleToUrl } from "@/utils/formatters";

const ImageContentSplit = ({ imageContentSplitData = {} }) => {
  const { locale } = useRouter()
  const {
    title: Title,
    description: Description,
    image = {},
    cta = {},
    showTrends = false
  } = imageContentSplitData;

  const {
    fields: {
      imageUrl: ImgURL,
      alt: AltText
    } = {}
  } = image;

  const {
    fields: {
      label: BtnLabel,
      url: BtnURL,
      ariaLabel: BtnAriaLabel
    }
  } = cta || {};

  
  let containerClass = showTrends ? styles.trendsContainer : styles.container;
  let contentClass = showTrends ? styles.trendsContent : styles.content;
  let imageClass  = showTrends ? styles.trendsImageWrapper : styles.imageWrapper;

  return (
    <section className={styles.section}>
      <div className={containerClass}>
        {/* Text panel */}
        <div className={contentClass}>
          <h2 className={styles.title}>{Title}</h2>
          <p className={styles.description}>
            {Description}
          </p>
          <a
            href={applyLocaleToUrl(BtnURL, locale)}
            aria-label={BtnAriaLabel}
            className={styles.button}
          >
            {BtnLabel}
          </a>
        </div>
        {/* Image panel */}
        {ImgURL && (
          <div className={imageClass}>
            <img src={ImgURL} alt={AltText} />
          </div>
        )}
      </div>
    </section>
  );
};

export default ImageContentSplit;

ImageContentSplit.defaultProps = {
  imageContentSplitData: {
    title: "",
    description: "",
    image: {
      fields: {
        imageUrl: ""
      }
    },
    cta: {
      fields: {
        label: "",
        url: "",
        ariaLabel: "",
        visible: true
      }
    }
  }
};

ImageContentSplit.propTypes = {
  imageContentSplitData: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.shape({
      fields: PropTypes.shape({
        imageUrl: PropTypes.string.isRequired
      })
    }),
    cta: PropTypes.shape({
      fields: PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        ariaLabel: PropTypes.string,
        visible: PropTypes.bool
      })
    })
  })
};
